module.exports = __webpack_public_path__ + "static/media/the-dutch-3.236957e8.jpg";